module.exports = __webpack_public_path__ + "static/media/logo-ob.01154a77.jpg";